// Fix jQuery passive listener
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};


jQuery(document).ready(function ($) {
    function debounce(func, wait) {
        var timer = null;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        }
    }

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px")); // We listen to the resize event

    window.addEventListener('resize', debounce(function(){
        // We execute the same script as before
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    }, 100));

    // Verificar qual tamanho da barra de rolagem
    function getScrollbarWidth() {
        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;
    }

    var scrollbar = getScrollbarWidth();

    // Menu mobile vars
    var hamburger = document.querySelector(".hamburger");
    var toogleMenu = document.querySelectorAll('.toggle-menu');
    var wrapper = document.querySelector('.menu-wrapper');
    var menuMobileOverlay = $('.menu-mobile-overlay');

    for (var i = 0; i < toogleMenu.length; i++){
        toogleMenu[i].addEventListener('click', menuAction);
    }

    // Search vars
    var toggleSearch = $('[data-search="toggle"]');
    var searchOverlay = $('.search-overlay');
    var screenSearch = $('.header-search-block');

    // Open menu mobile
    function openMenuMobile() {
        menuMobileOverlay.fadeIn();
        wrapper.classList.add('show-menu');
        hamburger.classList.add('is-active');
        if (screenSearch.is(':visible')) {
            closeSearchMobile();
        }
    }

    // Close menu mobile
    function closeMenuMobile() {
        menuMobileOverlay.fadeOut();
        wrapper.classList.remove('show-menu');
        hamburger.classList.remove('is-active');
    }

    // Open search
    function openSearchMobile() {
        screenSearch.addClass('is-active');
        screenSearch.fadeIn();
        searchOverlay.fadeIn();
        screenSearch.find('.search-field').focus();
        if (wrapper.classList.contains('show-menu')) {
            closeMenuMobile();
        }
    }

    // Close search
    function closeSearchMobile() {
        screenSearch.removeClass('is-active');
        screenSearch.fadeOut();
        searchOverlay.fadeOut();
    }

    // Trigger menu mobile
    function menuAction() {
        if(wrapper.classList.contains('show-menu')){
            closeMenuMobile();
        }
        else {
            openMenuMobile();
        }
    }

    // Open submenu mobile
    $('.mobile-nav .menu-item-has-children').click(function(event) {
        $('.mobile-nav .sub-menu .menu-item').click(function(event) {
            event.stopPropagation();
        });
        if ($(this).children('.sub-menu').is(':visible')) {
            $(this).removeClass('is-active');
            $(this).children('.sub-menu').slideUp();
        } else {
            $(this).addClass('is-active');
            $(this).children('.sub-menu').slideDown();
        }
    });

    // Trigger search mobile
    $(toggleSearch).click(function() {
        if (screenSearch.hasClass('is-active')) {
            closeSearchMobile();
        } else {
            openSearchMobile();
        }
    });

    // Open equipe-popup
    var scrollbar = getScrollbarWidth();
    var pItem = $('.popup-block');
    var pOverlay = $('.popup-overlay');

    $('body').on('click', '[data-popup="open"]', function(event) {
        var eItem = $(this).closest('.equipe-item').html();

        pItem.find('.popup-padding').html(eItem);
        pItem.fadeIn();
        pOverlay.fadeIn();

        $('html').css({'margin-right': scrollbar+'px', 'overflow': 'hidden'});
    });

    // Close equipe-popup
    $('body').on('click', '[data-popup="close"]', function(event) {
        pItem.fadeOut();
        pOverlay.fadeOut();

        setTimeout(function(){
            $('html').css({'margin-right': '', 'overflow': ''});
        }, 300);
    });

    // Open cat-blog menu
    $('[data-cat-mobile="toggle"]').click(function() {
        $(this).toggleClass('is-active');
        $(this).siblings('.cat-list').slideToggle();
    });

    // Open footer menu
    $('#footer-menu-btn').click(function() {
        $(this).toggleClass('is-active');
        $(this).siblings('.custom-menu-class').slideToggle();
    });

    // Trigger whatsapp (open/close)
    var whatsappPopup = $('#whatsapp-popup');

    $('[data-whatsapp-popup="toggle"]').click(function(event) {
        whatsappPopup.toggleClass('is-active');
        whatsappPopup.fadeToggle('fast');
        if (whatsappPopup.hasClass('is-active')) {
            $(whatsappPopup).find('input:first').focus();
            $('html').css({'overflow': 'hidden'});
        } else {
            setTimeout(function(){
                $('html').css({'overflow': ''});
            }, 300);
        }
    });

    // Nome do arquivo no input
    if ($("body").has("#input-file").length) {
        // click input file
        $('#input-file-btn').click(function() {
            $('#input-file').click();
        });

        var defaultText = $("#input-file-name").text();

        $('#input-file').bind('change', function(){
            $("#input-file-name").html(this.value.split(/(\\|\/)/g).pop());
            if ($('#input-file-name').is(':empty')){
                $("#input-file-name").html(defaultText);
            }
        });
    }

    // Anchor scroll
    $('a[href*="#"]:not([href="#"])').click(function (event) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var el = this;
            var hash = $($(this).attr('href'));
            var target = hash.length ? hash : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);

                // Fechar menu mobile
                closeMenuMobile();

                // Mudar hash na URL
                history.pushState({}, '', el.href);
            }
        }
    });

    $('a[href="#"]').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
        // Fechar menu mobile
        closeMenuMobile();
    });

    /*
    var hash = location.hash;

    if ($("body").has(hash).length) {
        $('html, body').animate({
            scrollTop: $($(hash).offset().top)
        }, 1000);
    }
    */

    $('.gallery-popup, .wp-block-gallery').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            tLoading: 'Carregando a imagem...',
            mainClass: 'mfp-no-margins mfp-fade',
            removalDelay: 300,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: 'A imagem não pode ser carregada.',
            },
        });
    });
});
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlcyI6WyJtYWluLm1pbi5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyBGaXggalF1ZXJ5IHBhc3NpdmUgbGlzdGVuZXJcclxualF1ZXJ5LmV2ZW50LnNwZWNpYWwudG91Y2hzdGFydCA9IHtcclxuICAgIHNldHVwOiBmdW5jdGlvbiggXywgbnMsIGhhbmRsZSApIHtcclxuICAgICAgICB0aGlzLmFkZEV2ZW50TGlzdGVuZXIoXCJ0b3VjaHN0YXJ0XCIsIGhhbmRsZSwgeyBwYXNzaXZlOiAhbnMuaW5jbHVkZXMoXCJub1ByZXZlbnREZWZhdWx0XCIpIH0pO1xyXG4gICAgfVxyXG59O1xyXG5qUXVlcnkuZXZlbnQuc3BlY2lhbC50b3VjaG1vdmUgPSB7XHJcbiAgICBzZXR1cDogZnVuY3Rpb24oIF8sIG5zLCBoYW5kbGUgKSB7XHJcbiAgICAgICAgdGhpcy5hZGRFdmVudExpc3RlbmVyKFwidG91Y2htb3ZlXCIsIGhhbmRsZSwgeyBwYXNzaXZlOiAhbnMuaW5jbHVkZXMoXCJub1ByZXZlbnREZWZhdWx0XCIpIH0pO1xyXG4gICAgfVxyXG59O1xyXG5qUXVlcnkuZXZlbnQuc3BlY2lhbC53aGVlbCA9IHtcclxuICAgIHNldHVwOiBmdW5jdGlvbiggXywgbnMsIGhhbmRsZSApe1xyXG4gICAgICAgIHRoaXMuYWRkRXZlbnRMaXN0ZW5lcihcIndoZWVsXCIsIGhhbmRsZSwgeyBwYXNzaXZlOiB0cnVlIH0pO1xyXG4gICAgfVxyXG59O1xyXG5qUXVlcnkuZXZlbnQuc3BlY2lhbC5tb3VzZXdoZWVsID0ge1xyXG4gICAgc2V0dXA6IGZ1bmN0aW9uKCBfLCBucywgaGFuZGxlICl7XHJcbiAgICAgICAgdGhpcy5hZGRFdmVudExpc3RlbmVyKFwibW91c2V3aGVlbFwiLCBoYW5kbGUsIHsgcGFzc2l2ZTogdHJ1ZSB9KTtcclxuICAgIH1cclxufTtcclxuXHJcblxyXG5qUXVlcnkoZG9jdW1lbnQpLnJlYWR5KGZ1bmN0aW9uICgkKSB7XHJcbiAgICBmdW5jdGlvbiBkZWJvdW5jZShmdW5jLCB3YWl0KSB7XHJcbiAgICAgICAgdmFyIHRpbWVyID0gbnVsbDtcclxuICAgICAgICByZXR1cm4gZnVuY3Rpb24oKSB7XHJcbiAgICAgICAgICAgIGNsZWFyVGltZW91dCh0aW1lcik7XHJcbiAgICAgICAgICAgIHRpbWVyID0gc2V0VGltZW91dChmdW5jLCB3YWl0KTtcclxuICAgICAgICB9XHJcbiAgICB9XHJcblxyXG4gICAgLy8gRmlyc3Qgd2UgZ2V0IHRoZSB2aWV3cG9ydCBoZWlnaHQgYW5kIHdlIG11bHRpcGxlIGl0IGJ5IDElIHRvIGdldCBhIHZhbHVlIGZvciBhIHZoIHVuaXRcclxuICAgIHZhciB2aCA9IHdpbmRvdy5pbm5lckhlaWdodCAqIDAuMDE7IC8vIFRoZW4gd2Ugc2V0IHRoZSB2YWx1ZSBpbiB0aGUgLS12aCBjdXN0b20gcHJvcGVydHkgdG8gdGhlIHJvb3Qgb2YgdGhlIGRvY3VtZW50XHJcblxyXG4gICAgZG9jdW1lbnQuZG9jdW1lbnRFbGVtZW50LnN0eWxlLnNldFByb3BlcnR5KCctLXZoJywgXCJcIi5jb25jYXQodmgsIFwicHhcIikpOyAvLyBXZSBsaXN0ZW4gdG8gdGhlIHJlc2l6ZSBldmVudFxyXG5cclxuICAgIHdpbmRvdy5hZGRFdmVudExpc3RlbmVyKCdyZXNpemUnLCBkZWJvdW5jZShmdW5jdGlvbigpe1xyXG4gICAgICAgIC8vIFdlIGV4ZWN1dGUgdGhlIHNhbWUgc2NyaXB0IGFzIGJlZm9yZVxyXG4gICAgICAgIHZhciB2aCA9IHdpbmRvdy5pbm5lckhlaWdodCAqIDAuMDE7XHJcbiAgICAgICAgZG9jdW1lbnQuZG9jdW1lbnRFbGVtZW50LnN0eWxlLnNldFByb3BlcnR5KCctLXZoJywgXCJcIi5jb25jYXQodmgsIFwicHhcIikpO1xyXG4gICAgfSwgMTAwKSk7XHJcblxyXG4gICAgLy8gVmVyaWZpY2FyIHF1YWwgdGFtYW5obyBkYSBiYXJyYSBkZSByb2xhZ2VtXHJcbiAgICBmdW5jdGlvbiBnZXRTY3JvbGxiYXJXaWR0aCgpIHtcclxuICAgICAgICAvLyBDcmVhdGluZyBpbnZpc2libGUgY29udGFpbmVyXHJcbiAgICAgICAgdmFyIG91dGVyID0gZG9jdW1lbnQuY3JlYXRlRWxlbWVudCgnZGl2Jyk7XHJcbiAgICAgICAgb3V0ZXIuc3R5bGUudmlzaWJpbGl0eSA9ICdoaWRkZW4nO1xyXG4gICAgICAgIG91dGVyLnN0eWxlLm92ZXJmbG93ID0gJ3Njcm9sbCc7IC8vIGZvcmNpbmcgc2Nyb2xsYmFyIHRvIGFwcGVhclxyXG4gICAgICAgIG91dGVyLnN0eWxlLm1zT3ZlcmZsb3dTdHlsZSA9ICdzY3JvbGxiYXInOyAvLyBuZWVkZWQgZm9yIFdpbkpTIGFwcHNcclxuICAgICAgICBkb2N1bWVudC5ib2R5LmFwcGVuZENoaWxkKG91dGVyKTtcclxuXHJcbiAgICAgICAgLy8gQ3JlYXRpbmcgaW5uZXIgZWxlbWVudCBhbmQgcGxhY2luZyBpdCBpbiB0aGUgY29udGFpbmVyXHJcbiAgICAgICAgdmFyIGlubmVyID0gZG9jdW1lbnQuY3JlYXRlRWxlbWVudCgnZGl2Jyk7XHJcbiAgICAgICAgb3V0ZXIuYXBwZW5kQ2hpbGQoaW5uZXIpO1xyXG5cclxuICAgICAgICAvLyBDYWxjdWxhdGluZyBkaWZmZXJlbmNlIGJldHdlZW4gY29udGFpbmVyJ3MgZnVsbCB3aWR0aCBhbmQgdGhlIGNoaWxkIHdpZHRoXHJcbiAgICAgICAgdmFyIHNjcm9sbGJhcldpZHRoID0gKG91dGVyLm9mZnNldFdpZHRoIC0gaW5uZXIub2Zmc2V0V2lkdGgpO1xyXG5cclxuICAgICAgICAvLyBSZW1vdmluZyB0ZW1wb3JhcnkgZWxlbWVudHMgZnJvbSB0aGUgRE9NXHJcbiAgICAgICAgb3V0ZXIucGFyZW50Tm9kZS5yZW1vdmVDaGlsZChvdXRlcik7XHJcblxyXG4gICAgICAgIHJldHVybiBzY3JvbGxiYXJXaWR0aDtcclxuICAgIH1cclxuXHJcbiAgICB2YXIgc2Nyb2xsYmFyID0gZ2V0U2Nyb2xsYmFyV2lkdGgoKTtcclxuXHJcbiAgICAvLyBNZW51IG1vYmlsZSB2YXJzXHJcbiAgICB2YXIgaGFtYnVyZ2VyID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihcIi5oYW1idXJnZXJcIik7XHJcbiAgICB2YXIgdG9vZ2xlTWVudSA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoJy50b2dnbGUtbWVudScpO1xyXG4gICAgdmFyIHdyYXBwZXIgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcubWVudS13cmFwcGVyJyk7XHJcbiAgICB2YXIgbWVudU1vYmlsZU92ZXJsYXkgPSAkKCcubWVudS1tb2JpbGUtb3ZlcmxheScpO1xyXG5cclxuICAgIGZvciAodmFyIGkgPSAwOyBpIDwgdG9vZ2xlTWVudS5sZW5ndGg7IGkrKyl7XHJcbiAgICAgICAgdG9vZ2xlTWVudVtpXS5hZGRFdmVudExpc3RlbmVyKCdjbGljaycsIG1lbnVBY3Rpb24pO1xyXG4gICAgfVxyXG5cclxuICAgIC8vIFNlYXJjaCB2YXJzXHJcbiAgICB2YXIgdG9nZ2xlU2VhcmNoID0gJCgnW2RhdGEtc2VhcmNoPVwidG9nZ2xlXCJdJyk7XHJcbiAgICB2YXIgc2VhcmNoT3ZlcmxheSA9ICQoJy5zZWFyY2gtb3ZlcmxheScpO1xyXG4gICAgdmFyIHNjcmVlblNlYXJjaCA9ICQoJy5oZWFkZXItc2VhcmNoLWJsb2NrJyk7XHJcblxyXG4gICAgLy8gT3BlbiBtZW51IG1vYmlsZVxyXG4gICAgZnVuY3Rpb24gb3Blbk1lbnVNb2JpbGUoKSB7XHJcbiAgICAgICAgbWVudU1vYmlsZU92ZXJsYXkuZmFkZUluKCk7XHJcbiAgICAgICAgd3JhcHBlci5jbGFzc0xpc3QuYWRkKCdzaG93LW1lbnUnKTtcclxuICAgICAgICBoYW1idXJnZXIuY2xhc3NMaXN0LmFkZCgnaXMtYWN0aXZlJyk7XHJcbiAgICAgICAgaWYgKHNjcmVlblNlYXJjaC5pcygnOnZpc2libGUnKSkge1xyXG4gICAgICAgICAgICBjbG9zZVNlYXJjaE1vYmlsZSgpO1xyXG4gICAgICAgIH1cclxuICAgIH1cclxuXHJcbiAgICAvLyBDbG9zZSBtZW51IG1vYmlsZVxyXG4gICAgZnVuY3Rpb24gY2xvc2VNZW51TW9iaWxlKCkge1xyXG4gICAgICAgIG1lbnVNb2JpbGVPdmVybGF5LmZhZGVPdXQoKTtcclxuICAgICAgICB3cmFwcGVyLmNsYXNzTGlzdC5yZW1vdmUoJ3Nob3ctbWVudScpO1xyXG4gICAgICAgIGhhbWJ1cmdlci5jbGFzc0xpc3QucmVtb3ZlKCdpcy1hY3RpdmUnKTtcclxuICAgIH1cclxuXHJcbiAgICAvLyBPcGVuIHNlYXJjaFxyXG4gICAgZnVuY3Rpb24gb3BlblNlYXJjaE1vYmlsZSgpIHtcclxuICAgICAgICBzY3JlZW5TZWFyY2guYWRkQ2xhc3MoJ2lzLWFjdGl2ZScpO1xyXG4gICAgICAgIHNjcmVlblNlYXJjaC5mYWRlSW4oKTtcclxuICAgICAgICBzZWFyY2hPdmVybGF5LmZhZGVJbigpO1xyXG4gICAgICAgIHNjcmVlblNlYXJjaC5maW5kKCcuc2VhcmNoLWZpZWxkJykuZm9jdXMoKTtcclxuICAgICAgICBpZiAod3JhcHBlci5jbGFzc0xpc3QuY29udGFpbnMoJ3Nob3ctbWVudScpKSB7XHJcbiAgICAgICAgICAgIGNsb3NlTWVudU1vYmlsZSgpO1xyXG4gICAgICAgIH1cclxuICAgIH1cclxuXHJcbiAgICAvLyBDbG9zZSBzZWFyY2hcclxuICAgIGZ1bmN0aW9uIGNsb3NlU2VhcmNoTW9iaWxlKCkge1xyXG4gICAgICAgIHNjcmVlblNlYXJjaC5yZW1vdmVDbGFzcygnaXMtYWN0aXZlJyk7XHJcbiAgICAgICAgc2NyZWVuU2VhcmNoLmZhZGVPdXQoKTtcclxuICAgICAgICBzZWFyY2hPdmVybGF5LmZhZGVPdXQoKTtcclxuICAgIH1cclxuXHJcbiAgICAvLyBUcmlnZ2VyIG1lbnUgbW9iaWxlXHJcbiAgICBmdW5jdGlvbiBtZW51QWN0aW9uKCkge1xyXG4gICAgICAgIGlmKHdyYXBwZXIuY2xhc3NMaXN0LmNvbnRhaW5zKCdzaG93LW1lbnUnKSl7XHJcbiAgICAgICAgICAgIGNsb3NlTWVudU1vYmlsZSgpO1xyXG4gICAgICAgIH1cclxuICAgICAgICBlbHNlIHtcclxuICAgICAgICAgICAgb3Blbk1lbnVNb2JpbGUoKTtcclxuICAgICAgICB9XHJcbiAgICB9XHJcblxyXG4gICAgLy8gT3BlbiBzdWJtZW51IG1vYmlsZVxyXG4gICAgJCgnLm1vYmlsZS1uYXYgLm1lbnUtaXRlbS1oYXMtY2hpbGRyZW4nKS5jbGljayhmdW5jdGlvbihldmVudCkge1xyXG4gICAgICAgICQoJy5tb2JpbGUtbmF2IC5zdWItbWVudSAubWVudS1pdGVtJykuY2xpY2soZnVuY3Rpb24oZXZlbnQpIHtcclxuICAgICAgICAgICAgZXZlbnQuc3RvcFByb3BhZ2F0aW9uKCk7XHJcbiAgICAgICAgfSk7XHJcbiAgICAgICAgaWYgKCQodGhpcykuY2hpbGRyZW4oJy5zdWItbWVudScpLmlzKCc6dmlzaWJsZScpKSB7XHJcbiAgICAgICAgICAgICQodGhpcykucmVtb3ZlQ2xhc3MoJ2lzLWFjdGl2ZScpO1xyXG4gICAgICAgICAgICAkKHRoaXMpLmNoaWxkcmVuKCcuc3ViLW1lbnUnKS5zbGlkZVVwKCk7XHJcbiAgICAgICAgfSBlbHNlIHtcclxuICAgICAgICAgICAgJCh0aGlzKS5hZGRDbGFzcygnaXMtYWN0aXZlJyk7XHJcbiAgICAgICAgICAgICQodGhpcykuY2hpbGRyZW4oJy5zdWItbWVudScpLnNsaWRlRG93bigpO1xyXG4gICAgICAgIH1cclxuICAgIH0pO1xyXG5cclxuICAgIC8vIFRyaWdnZXIgc2VhcmNoIG1vYmlsZVxyXG4gICAgJCh0b2dnbGVTZWFyY2gpLmNsaWNrKGZ1bmN0aW9uKCkge1xyXG4gICAgICAgIGlmIChzY3JlZW5TZWFyY2guaGFzQ2xhc3MoJ2lzLWFjdGl2ZScpKSB7XHJcbiAgICAgICAgICAgIGNsb3NlU2VhcmNoTW9iaWxlKCk7XHJcbiAgICAgICAgfSBlbHNlIHtcclxuICAgICAgICAgICAgb3BlblNlYXJjaE1vYmlsZSgpO1xyXG4gICAgICAgIH1cclxuICAgIH0pO1xyXG5cclxuICAgIC8vIE9wZW4gZXF1aXBlLXBvcHVwXHJcbiAgICB2YXIgc2Nyb2xsYmFyID0gZ2V0U2Nyb2xsYmFyV2lkdGgoKTtcclxuICAgIHZhciBwSXRlbSA9ICQoJy5wb3B1cC1ibG9jaycpO1xyXG4gICAgdmFyIHBPdmVybGF5ID0gJCgnLnBvcHVwLW92ZXJsYXknKTtcclxuXHJcbiAgICAkKCdib2R5Jykub24oJ2NsaWNrJywgJ1tkYXRhLXBvcHVwPVwib3BlblwiXScsIGZ1bmN0aW9uKGV2ZW50KSB7XHJcbiAgICAgICAgdmFyIGVJdGVtID0gJCh0aGlzKS5jbG9zZXN0KCcuZXF1aXBlLWl0ZW0nKS5odG1sKCk7XHJcblxyXG4gICAgICAgIHBJdGVtLmZpbmQoJy5wb3B1cC1wYWRkaW5nJykuaHRtbChlSXRlbSk7XHJcbiAgICAgICAgcEl0ZW0uZmFkZUluKCk7XHJcbiAgICAgICAgcE92ZXJsYXkuZmFkZUluKCk7XHJcblxyXG4gICAgICAgICQoJ2h0bWwnKS5jc3MoeydtYXJnaW4tcmlnaHQnOiBzY3JvbGxiYXIrJ3B4JywgJ292ZXJmbG93JzogJ2hpZGRlbid9KTtcclxuICAgIH0pO1xyXG5cclxuICAgIC8vIENsb3NlIGVxdWlwZS1wb3B1cFxyXG4gICAgJCgnYm9keScpLm9uKCdjbGljaycsICdbZGF0YS1wb3B1cD1cImNsb3NlXCJdJywgZnVuY3Rpb24oZXZlbnQpIHtcclxuICAgICAgICBwSXRlbS5mYWRlT3V0KCk7XHJcbiAgICAgICAgcE92ZXJsYXkuZmFkZU91dCgpO1xyXG5cclxuICAgICAgICBzZXRUaW1lb3V0KGZ1bmN0aW9uKCl7XHJcbiAgICAgICAgICAgICQoJ2h0bWwnKS5jc3MoeydtYXJnaW4tcmlnaHQnOiAnJywgJ292ZXJmbG93JzogJyd9KTtcclxuICAgICAgICB9LCAzMDApO1xyXG4gICAgfSk7XHJcblxyXG4gICAgLy8gT3BlbiBjYXQtYmxvZyBtZW51XHJcbiAgICAkKCdbZGF0YS1jYXQtbW9iaWxlPVwidG9nZ2xlXCJdJykuY2xpY2soZnVuY3Rpb24oKSB7XHJcbiAgICAgICAgJCh0aGlzKS50b2dnbGVDbGFzcygnaXMtYWN0aXZlJyk7XHJcbiAgICAgICAgJCh0aGlzKS5zaWJsaW5ncygnLmNhdC1saXN0Jykuc2xpZGVUb2dnbGUoKTtcclxuICAgIH0pO1xyXG5cclxuICAgIC8vIE9wZW4gZm9vdGVyIG1lbnVcclxuICAgICQoJyNmb290ZXItbWVudS1idG4nKS5jbGljayhmdW5jdGlvbigpIHtcclxuICAgICAgICAkKHRoaXMpLnRvZ2dsZUNsYXNzKCdpcy1hY3RpdmUnKTtcclxuICAgICAgICAkKHRoaXMpLnNpYmxpbmdzKCcuY3VzdG9tLW1lbnUtY2xhc3MnKS5zbGlkZVRvZ2dsZSgpO1xyXG4gICAgfSk7XHJcblxyXG4gICAgLy8gVHJpZ2dlciB3aGF0c2FwcCAob3Blbi9jbG9zZSlcclxuICAgIHZhciB3aGF0c2FwcFBvcHVwID0gJCgnI3doYXRzYXBwLXBvcHVwJyk7XHJcblxyXG4gICAgJCgnW2RhdGEtd2hhdHNhcHAtcG9wdXA9XCJ0b2dnbGVcIl0nKS5jbGljayhmdW5jdGlvbihldmVudCkge1xyXG4gICAgICAgIHdoYXRzYXBwUG9wdXAudG9nZ2xlQ2xhc3MoJ2lzLWFjdGl2ZScpO1xyXG4gICAgICAgIHdoYXRzYXBwUG9wdXAuZmFkZVRvZ2dsZSgnZmFzdCcpO1xyXG4gICAgICAgIGlmICh3aGF0c2FwcFBvcHVwLmhhc0NsYXNzKCdpcy1hY3RpdmUnKSkge1xyXG4gICAgICAgICAgICAkKHdoYXRzYXBwUG9wdXApLmZpbmQoJ2lucHV0OmZpcnN0JykuZm9jdXMoKTtcclxuICAgICAgICAgICAgJCgnaHRtbCcpLmNzcyh7J292ZXJmbG93JzogJ2hpZGRlbid9KTtcclxuICAgICAgICB9IGVsc2Uge1xyXG4gICAgICAgICAgICBzZXRUaW1lb3V0KGZ1bmN0aW9uKCl7XHJcbiAgICAgICAgICAgICAgICAkKCdodG1sJykuY3NzKHsnb3ZlcmZsb3cnOiAnJ30pO1xyXG4gICAgICAgICAgICB9LCAzMDApO1xyXG4gICAgICAgIH1cclxuICAgIH0pO1xyXG5cclxuICAgIC8vIE5vbWUgZG8gYXJxdWl2byBubyBpbnB1dFxyXG4gICAgaWYgKCQoXCJib2R5XCIpLmhhcyhcIiNpbnB1dC1maWxlXCIpLmxlbmd0aCkge1xyXG4gICAgICAgIC8vIGNsaWNrIGlucHV0IGZpbGVcclxuICAgICAgICAkKCcjaW5wdXQtZmlsZS1idG4nKS5jbGljayhmdW5jdGlvbigpIHtcclxuICAgICAgICAgICAgJCgnI2lucHV0LWZpbGUnKS5jbGljaygpO1xyXG4gICAgICAgIH0pO1xyXG5cclxuICAgICAgICB2YXIgZGVmYXVsdFRleHQgPSAkKFwiI2lucHV0LWZpbGUtbmFtZVwiKS50ZXh0KCk7XHJcblxyXG4gICAgICAgICQoJyNpbnB1dC1maWxlJykuYmluZCgnY2hhbmdlJywgZnVuY3Rpb24oKXtcclxuICAgICAgICAgICAgJChcIiNpbnB1dC1maWxlLW5hbWVcIikuaHRtbCh0aGlzLnZhbHVlLnNwbGl0KC8oXFxcXHxcXC8pL2cpLnBvcCgpKTtcclxuICAgICAgICAgICAgaWYgKCQoJyNpbnB1dC1maWxlLW5hbWUnKS5pcygnOmVtcHR5Jykpe1xyXG4gICAgICAgICAgICAgICAgJChcIiNpbnB1dC1maWxlLW5hbWVcIikuaHRtbChkZWZhdWx0VGV4dCk7XHJcbiAgICAgICAgICAgIH1cclxuICAgICAgICB9KTtcclxuICAgIH1cclxuXHJcbiAgICAvLyBBbmNob3Igc2Nyb2xsXHJcbiAgICAkKCdhW2hyZWYqPVwiI1wiXTpub3QoW2hyZWY9XCIjXCJdKScpLmNsaWNrKGZ1bmN0aW9uIChldmVudCkge1xyXG4gICAgICAgIGV2ZW50LnByZXZlbnREZWZhdWx0KCk7XHJcbiAgICAgICAgaWYgKGxvY2F0aW9uLnBhdGhuYW1lLnJlcGxhY2UoL15cXC8vLCAnJykgPT0gdGhpcy5wYXRobmFtZS5yZXBsYWNlKC9eXFwvLywgJycpICYmIGxvY2F0aW9uLmhvc3RuYW1lID09IHRoaXMuaG9zdG5hbWUpIHtcclxuICAgICAgICAgICAgdmFyIGVsID0gdGhpcztcclxuICAgICAgICAgICAgdmFyIGhhc2ggPSAkKCQodGhpcykuYXR0cignaHJlZicpKTtcclxuICAgICAgICAgICAgdmFyIHRhcmdldCA9IGhhc2gubGVuZ3RoID8gaGFzaCA6ICQoJ1tuYW1lPScgKyB0aGlzLmhhc2guc2xpY2UoMSkgKyAnXScpO1xyXG4gICAgICAgICAgICBpZiAodGFyZ2V0Lmxlbmd0aCkge1xyXG4gICAgICAgICAgICAgICAgJCgnaHRtbCwgYm9keScpLmFuaW1hdGUoe1xyXG4gICAgICAgICAgICAgICAgICAgIHNjcm9sbFRvcDogdGFyZ2V0Lm9mZnNldCgpLnRvcFxyXG4gICAgICAgICAgICAgICAgfSwgMTAwMCk7XHJcblxyXG4gICAgICAgICAgICAgICAgLy8gRmVjaGFyIG1lbnUgbW9iaWxlXHJcbiAgICAgICAgICAgICAgICBjbG9zZU1lbnVNb2JpbGUoKTtcclxuXHJcbiAgICAgICAgICAgICAgICAvLyBNdWRhciBoYXNoIG5hIFVSTFxyXG4gICAgICAgICAgICAgICAgaGlzdG9yeS5wdXNoU3RhdGUoe30sICcnLCBlbC5ocmVmKTtcclxuICAgICAgICAgICAgfVxyXG4gICAgICAgIH1cclxuICAgIH0pO1xyXG5cclxuICAgICQoJ2FbaHJlZj1cIiNcIl0nKS5jbGljayhmdW5jdGlvbiAoKSB7XHJcbiAgICAgICAgJCgnaHRtbCwgYm9keScpLmFuaW1hdGUoe1xyXG4gICAgICAgICAgICBzY3JvbGxUb3A6IDBcclxuICAgICAgICB9LCAxMDAwKTtcclxuICAgICAgICAvLyBGZWNoYXIgbWVudSBtb2JpbGVcclxuICAgICAgICBjbG9zZU1lbnVNb2JpbGUoKTtcclxuICAgIH0pO1xyXG5cclxuICAgIC8qXHJcbiAgICB2YXIgaGFzaCA9IGxvY2F0aW9uLmhhc2g7XHJcblxyXG4gICAgaWYgKCQoXCJib2R5XCIpLmhhcyhoYXNoKS5sZW5ndGgpIHtcclxuICAgICAgICAkKCdodG1sLCBib2R5JykuYW5pbWF0ZSh7XHJcbiAgICAgICAgICAgIHNjcm9sbFRvcDogJCgkKGhhc2gpLm9mZnNldCgpLnRvcClcclxuICAgICAgICB9LCAxMDAwKTtcclxuICAgIH1cclxuICAgICovXHJcblxyXG4gICAgJCgnLmdhbGxlcnktcG9wdXAsIC53cC1ibG9jay1nYWxsZXJ5JykuZWFjaChmdW5jdGlvbigpIHsgLy8gdGhlIGNvbnRhaW5lcnMgZm9yIGFsbCB5b3VyIGdhbGxlcmllc1xyXG4gICAgICAgICQodGhpcykubWFnbmlmaWNQb3B1cCh7XHJcbiAgICAgICAgICAgIGRlbGVnYXRlOiAnYScsXHJcbiAgICAgICAgICAgIHR5cGU6ICdpbWFnZScsXHJcbiAgICAgICAgICAgIGNsb3NlT25Db250ZW50Q2xpY2s6IHRydWUsXHJcbiAgICAgICAgICAgIGNsb3NlQnRuSW5zaWRlOiBmYWxzZSxcclxuICAgICAgICAgICAgZml4ZWRDb250ZW50UG9zOiB0cnVlLFxyXG4gICAgICAgICAgICB0TG9hZGluZzogJ0NhcnJlZ2FuZG8gYSBpbWFnZW0uLi4nLFxyXG4gICAgICAgICAgICBtYWluQ2xhc3M6ICdtZnAtbm8tbWFyZ2lucyBtZnAtZmFkZScsXHJcbiAgICAgICAgICAgIHJlbW92YWxEZWxheTogMzAwLFxyXG4gICAgICAgICAgICBnYWxsZXJ5OiB7XHJcbiAgICAgICAgICAgICAgICBlbmFibGVkOiB0cnVlLFxyXG4gICAgICAgICAgICAgICAgbmF2aWdhdGVCeUltZ0NsaWNrOiB0cnVlLFxyXG4gICAgICAgICAgICAgICAgcHJlbG9hZDogWzAsMV0gLy8gV2lsbCBwcmVsb2FkIDAgLSBiZWZvcmUgY3VycmVudCwgYW5kIDEgYWZ0ZXIgdGhlIGN1cnJlbnQgaW1hZ2VcclxuICAgICAgICAgICAgfSxcclxuICAgICAgICAgICAgaW1hZ2U6IHtcclxuICAgICAgICAgICAgICAgIHRFcnJvcjogJ0EgaW1hZ2VtIG7Do28gcG9kZSBzZXIgY2FycmVnYWRhLicsXHJcbiAgICAgICAgICAgIH0sXHJcbiAgICAgICAgfSk7XHJcbiAgICB9KTtcclxufSk7Il0sImZpbGUiOiJtYWluLm1pbi5qcyJ9
